import { render, staticRenderFns } from "./WhatsAppGroupsFreshPrograms.vue?vue&type=template&id=02b2ce23&scoped=true&"
import script from "./WhatsAppGroupsFreshPrograms.vue?vue&type=script&lang=js&"
export * from "./WhatsAppGroupsFreshPrograms.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppGroupsFreshPrograms.vue?vue&type=style&index=0&id=02b2ce23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b2ce23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VDataTable,VRow,VSelect})
